'use strict';
module.exports = function codePointForStickerDescriptor(stickerDescriptor) {
	const components = stickerDescriptor && typeof stickerDescriptor === 'string' && stickerDescriptor.split(':');
	if (!components || components.length !== 2 || components[0] !== 'emoji') {
		throw new Error('invalid-args');
	}
	return components[1];
};

